
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'Content',
  props: {
    content: {
      type: Object,
      default: null
    }
  },
  setup () {
    const colors = ['list-group-item-primary', 'list-group-item-secondary', 'list-group-item-danger', 'list-group-item-warning', 'list-group-item-info', 'list-group-item-light', 'list-group-item-dark']
    return {
      colors
    }
  },
  mounted () {
    this.setQAColor()
  },
  updated () {
    this.setQAColor()
  },
  methods: {
    setQAColor (): void {
      let i = 0
      for (const div of document.getElementsByClassName('list-group-item')) {
        div.classList.add(this.colors[i++])
        i %= this.colors.length
      }
    }
  }
})
